import { ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from 'recharts';
import type { HourPoint } from '../../types/weather';
import { chartTheme } from './chartTheme';

export function HourlyWindChart({ hourly }: { hourly: HourPoint[] }) {
  const data = hourly.map(h => ({ time: h.timeLocal, Wind: h.windMph, Gusts: h.gustsMph }));
  return (
    <div className="h-28">
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart data={data} margin={{ top: 6, right: 12, bottom: 0, left: 4 }}>
          <CartesianGrid strokeDasharray="2 4" stroke={chartTheme.grid} vertical={false} />
          <XAxis dataKey="time" tick={chartTheme.tick} interval={3} stroke={chartTheme.grid} />
          <YAxis tick={chartTheme.tick} width={36} stroke={chartTheme.grid} tickFormatter={(v: number) => `${Math.round(v)}`} />
          <Tooltip
            contentStyle={chartTheme.tooltip.contentStyle}
            labelStyle={chartTheme.tooltip.labelStyle}
            itemStyle={chartTheme.tooltip.itemStyle}
            formatter={(v) => `${Math.round(Number(v))} mph`}
          />
          <Legend wrapperStyle={chartTheme.legend.wrapperStyle} iconSize={8} />
          <Bar  dataKey="Wind"  fill="#3b82f6" radius={[2, 2, 0, 0]} />
          <Line type="monotone" dataKey="Gusts" stroke="#fbbf24" dot={false} strokeWidth={2} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
